import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import SvgIcon from "@/components/common/SvgIcon";
import VueAwesomeSwiper from "vue-awesome-swiper";
import {
  Swiper as SwiperClass,
  Mousewheel,
  Pagination,
} from "swiper/swiper.esm";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
SwiperClass.use([Mousewheel, Pagination]);
Vue.use(getAwesomeSwiper(SwiperClass));
import "swiper/swiper-bundle.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faFacebookSquare,
  faLine,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import VueGtag from "vue-gtag";
import VueHead from 'vue-head';

Vue.use(VueHead);

Vue.use(
  VueGtag,
  {
    config: { id: "UA-42254325-1" },
    includes: [
      { id: 'UA-24781369-2' },
      { id: 'UA-24781369-6' }
    ]
  },
  router
);
Vue.use(VueAwesomeSwiper);
Vue.use(BootstrapVue);
Vue.component("svg-icon", SvgIcon);

import VueMeta from 'vue-meta'
Vue.use(VueMeta)

library.add(
  faFacebookSquare,
  faLine,
  faYoutube,
);

Vue.component("font-awesome-icon", FontAwesomeIcon); //使用kebab-case

const requireAll = (requireContext) =>
  requireContext.keys().map(requireContext);
const req = require.context("@/icons", true, /\.svg$/);
requireAll(req);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
